module.exports = __webpack_public_path__ + "img/375.78b9eb1c.jpg";